import React, {Fragment, useRef} from 'react';
import {connect} from "react-redux";
import {SIDEBAR_SLAB_BUTTONS} from "../../constants";
import {FormattedMessage} from "react-intl";
import {setSQFTActiveButton, setSQFTMenuOpened, setSQFTMenuOpenedLock} from "../../../../actions/sqftMenuFunctions";
import {useOutsideClick} from "../../../../misc/helperHooks";
import SlabToolSwitcher from "./menuSwitchers/SlabToolSwitcher";
import SqftSlabWindow from "../slab/SqftSlabWindow";
import {clearAllMenusEvents} from "../canvas/core/workspace/workspaceEvents";

const SqftNavAsideSlabMode = (props) => {
  // other popups, modals and so on
  const {isShowSlabTool, menuOpenedLock, activeButton, setSQFTMenuOpenedLock} = props;
  const {menuOpened, setSQFTActiveButton, setSQFTMenuOpened} = props;
  const dropdownElement = useRef(null);

  useOutsideClick(dropdownElement, (event) => {
    const disallowClasses = [".sidebar", ".sidebar2", ".side", ".expanded", ".full-screen-wrapper", ".info-panel-button__hidden"];
    if (!disallowClasses.some(cls => event.target.closest(cls))) {
      if (menuOpenedLock) {
        setSQFTMenuOpenedLock(false); // lock menu for one click
      } else {
        setSQFTMenuOpened("");
      }
    }
  }, true);

  const handleButtonClick = (button) => {
    clearAllMenusEvents();
    setSQFTActiveButton(button);
    switch (button) {
      case SIDEBAR_SLAB_BUTTONS.loadSlab:
      case SIDEBAR_SLAB_BUTTONS.seam:
        setSQFTMenuOpened(menuOpened ? "": button );
        break;
      default:
        setSQFTMenuOpened("");
    }
  };

  return (
    <Fragment>
      {
        isShowSlabTool ? <SqftSlabWindow/> : null
      }
      <aside className={"sidebar " + (isShowSlabTool ? "": "hidden")} ref={dropdownElement} >
        <div className="sidebar-buttons">
          <div className="sidebar-buttons--top">
            {Object.keys(SIDEBAR_SLAB_BUTTONS).map((item, index) => (
              <button key={index}
                      className={"button button--"+ item + (activeButton === item ? " button--active" : "")}
                      onClick={() => handleButtonClick(item)}
                      title={item}>
                <span className="button-text">
                  <FormattedMessage id={"sqft.navigation.slabmenu." + item}/>
                </span>
              </button>
            ))}
          </div>
          <div className="sidebar-buttons--bottom-mobile">
            <div className="sidebar-separator hide-mobile"/>
            <SlabToolSwitcher overlay={false}/>
          </div>
        </div>
      </aside>
    </Fragment>
  )
};

const mapStateToProps = (store) => ({
  isShowSlabTool: store.sqftSlabState.isShowSlabTool,
  menuOpened: store.sqftMenuState.menuOpened,
  menuOpenedLock: store.sqftMenuState.menuOpenedLock,
  activeButton: store.sqftMenuState.activeButton
});

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTMenuOpenedLock,
  setSQFTActiveButton
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavAsideSlabMode);
